<script lang="ts">
	export let title = "";
	//Using Profile

</script>

<div class="container">
	<div class="header">
		<h1>{title}</h1>
		<div class="actions">
			<slot name="actions" />
		</div>
	</div>
	<div class="contents">
		<slot />
	</div>
</div>

<style lang="scss">
	@import "../variables.scss";

	//Mobile First
	.container {
		position: relative;
		display: flex;
		flex-direction: column;
		width: 100%;
		min-height: 100%;

		.header {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 24px;

			position: relative;
			h1 {
				color: var(--background-1);
				font-weight: 500;
				font-size: 1.25rem;
			}

			.actions {
				position: absolute;
				top: 0;
				right: 0;
			}
		}
		.contents {
			width: 100%;
			flex-grow: 1;
		}
	}
	@include DesktopSize {
		.container {
			margin-top: 30px;
			.header {
				justify-content: space-between;
				align-items: baseline;
				height: auto;

				h1 {
					font-size: 2.1875rem;
					font-weight: 600;
				}

				.actions {
					position: static;
				}
			}
		}
	}

</style>
